import { render, staticRenderFns } from "./InquiriesViewActions.vue?vue&type=template&id=5e732482"
import script from "./InquiriesViewActions.vue?vue&type=script&lang=js"
export * from "./InquiriesViewActions.vue?vue&type=script&lang=js"
import style0 from "./InquiriesViewActions.vue?vue&type=style&index=0&id=5e732482&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports